import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Img from '../../assets/images/og-logo.png'
import { HashLink } from 'react-router-hash-link';



function Header() {

    const [Show, setShow] = useState()
    const [Mobile, setMobile] = useState()
    const [Home, setHome] = useState(false)
    const [Page, setPage] = useState(false)
    const [Insurances, setInsurances] = useState(false)
    const [Portfolio, setPortfolio] = useState(false)
    const [Blog, setBlog] = useState(false)
    const [Btnshow, setBtnshow] = useState(false);

    return (
        <>
            <header className="main-header-two main-header-two--home-1 " >
                <nav className="main-menu-two sticky-header">
                    <div className="container-fluid">
                        <div className="main-menu-two__left">
                            <Link to="/" className="main-header__logo">
                                <img src={Img} style={{ height: '50px', width: 'auto' }} />
                            </Link>
                            <Link to="#" className="main-header__toggler mobile-nav__toggler" onClick={() => setMobile(true)}>
                                <span />
                                <span />
                                <span />
                            </Link>
                        </div>

                        <ul className="main-menu__list">
                            <li className="men  u-item-has-children">
                                <Link to="/">Home</Link>
                                {/* <ul>
                        <li>
                        <Link to="/">Home one</Link>
                        </li>
                        <li>
                        <Link to="/hometwo">Home two</Link>
                        </li>
                        <li>
                        <Link to="/homethree">Home three</Link>
                        </li>
                        <li>
                        <Link to="/homefour">Home four</Link>
                        </li>
                        <li className="menu-item-has-children">
                        <Link to="/">Header styles</Link>
                        <ul>
                            <li>
                            <Link to="/">Header one</Link>
                            </li>
                            <li>
                            <Link to="/hometwo">Header two</Link>
                            </li>
                            <li>
                            <Link to="homethree">Header three</Link>
                            </li>
                            <li>
                            <Link to="/homefour">Header four</Link>
                            </li>
                        </ul>
                        </li>
                    </ul> */}
                            </li>
                            <li className="menu-item-has-children">
                                <Link to="/about">About Us</Link>

                            </li>
                            <li className="menu-item-has-children">
                                <Link to="/insurances">Insurances</Link>
                                <ul>
                                    <li>
                                        <Link to="/insurances">Insurances</Link>
                                    </li>
                                    <li>
                                        <Link to="/pay-premium">Pay Premium</Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="menu-item-has-children">
                                <Link to="/">Booking</Link>
                                <ul>
                                     <li>
                                        <a href="https://journey.finrelinsure.com?authToken=1&userID=9241902343181004&token=2&hashPan=8cd8edaccb16e49e2c6b70f52360c59eab1b6f0576463219f5676588d52533360b6c35afaae5ebe5cdfd49c9cd8b294bd60b455155986dc7277f6a3cbd4dc73f&mobile=9873367772" target="_blank" rel="noopener noreferrer">Ferry</a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link to="/contact">Contact Us</Link>
                            </li>
                        </ul>

                        <div className="main-menu-two__right">
                            <span className=''>
                                <p className='my-0' style={{ fontSize: "12px", lineHeight: "1.3em", fontWeight: "bold", color: "#00041b",fontFamily:'"Red Hat Display", sans-serif', maxWidth:"160px" }}>IRDA License No : IMF09640820250838</p>
                            </span>
                            {/* <Link to="#" style={{
                                fontSize: "22px",
                                color: "#00041b",
                                backgroundColor: "transparent",
                                padding: "5px",

                            }}>
                                <i className="far fa-search" onClick={() => { setBtnshow(true) }} />
                            </Link> */}
                            <HashLink
                                smooth
                                to="/#getaquote"
                                scroll={el => window.scrollTo({ top: el.offsetTop - 100, behavior: 'smooth' })}
                                className="thm-btn"
                            >
                                <span>
                                    Get a Quote <i className="far fa-arrow-right" />
                                </span>
                            </HashLink>
                            <button className='thm-btn' onClick={() => window.location.href = 'https://auth.finrelinsure.com'}>
                                <span> Login </span>
                            </button>

                            {/* <Link to="#" className="main-menu__toggler side-drawer__toggler" onClick={() => {}}>
                    <span />
                    <span />
                    <span />
                    </Link> */}
                        </div>

                    </div>
                </nav>

                <nav className="main-menu-two sticky-header sticky-header--cloned sticky-fixed ">
                    <div className="container-fluid">
                        <div className="main-menu-two__left">
                            <Link to="/" className="main-header__logo">
                                <img src={Img} style={{ height: '50px', width: 'auto' }} />
                            </Link>
                            <Link to="#" className="main-header__toggler mobile-nav__toggler" onClick={() => setMobile(true)}>
                                <span />
                                <span />
                                <span />
                            </Link>
                        </div>

                        <ul className="main-menu__list">
                            <li className="menu-item-has-children current">
                                <Link to="/">Home</Link>
                                {/* <ul>
                        <li className="current">
                            <Link to="/">Home one</Link>
                        </li>
                        <li>
                            <Link to="/hometwo">Home two</Link>
                        </li>
                        <li>
                            <Link to="/homethree">Home three</Link>
                        </li>
                        <li>
                            <Link to="homefour">Home four</Link>
                        </li>
                        <li className="menu-item-has-children current">
                            <Link to="/">Header styles</Link>
                            <ul>
                            <li className="current">
                                <Link to="/">Header one</Link>
                            </li>
                            <li>
                                <Link to="/hometwo">Header two</Link>
                            </li>
                            <li>
                                <Link to="/homethree">Header three</Link>
                            </li>
                            <li>
                                <Link to="/homefour">Header four</Link>
                            </li>
                            </ul>
                        </li>
                        </ul> */}
                            </li>
                            <li className="menu-item-has-children">
                                <Link to="/about">About Us</Link>
                                {/* <ul>
                        <li>
                            <Link to="/about">About us</Link>
                        </li>
                        <li>
                            <Link to="/team">Team</Link>
                        </li>
                        <li>
                            <Link to="/teamdetails">Team details</Link>
                        </li>
                        <li>
                            <Link to="/faqs">Faq</Link>
                        </li>
                        <li>
                            <Link to="/pricing">Pricing</Link>
                        </li>
                        <li>
                            <Link to="/error">Error 404</Link>
                        </li>
                        </ul> */}
                            </li>
                            <li className="menu-item-has-children">
                                <Link to="/insurances">Insurances</Link>
                                <ul>
                                    <li>
                                        <Link to="/insurances">Insurances</Link>
                                    </li>
                                    <li>
                                        <Link to="/pay-premium">Pay Premium</Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="menu-item-has-children">
                                <Link to="/">Booking</Link>
                                <ul>
                                   <li>
                                        <a href="https://journey.finrelinsure.com?authToken=1&userID=9241902343181004&token=2&hashPan=8cd8edaccb16e49e2c6b70f52360c59eab1b6f0576463219f5676588d52533360b6c35afaae5ebe5cdfd49c9cd8b294bd60b455155986dc7277f6a3cbd4dc73f&mobile=9873367772" target="_blank" rel="noopener noreferrer">Ferry</a>
                                    </li>
                                </ul>
                            </li>
                            <li className="menu-item-has-children">
                                {/* <Link to="/faqs">FAQs</Link> */}
                                {/* <ul>
                        <li>
                            <Link to="/portfoliogrid">Portfolio grid</Link>
                        </li>
                        <li>
                            <Link to="/portfoliomasonary">Portfolio masonary</Link>
                        </li>
                        <li>
                            <Link to="/portfoliodetails">Portfolio details</Link>
                        </li>
                        </ul> */}
                            </li>
                            {/* <li className="menu-item-has-children">
                        <Link to="/blog">Blog</Link>
                        <ul>
                        <li>
                            <Link to="/blog">Blog</Link>
                        </li>
                        <li>
                            <Link to="/blogdetails">Blog details</Link>
                        </li>
                        </ul>
                    </li> */}
                            <li>
                                <Link to="/contact">Contact Us</Link>
                            </li>
                        </ul>

                        <div className="main-menu-two__right">
                            <p className='my-0' style={{ fontSize: "12px", lineHeight: "1.3em", fontWeight: "bold", color: "#00041b", fontFamily: '"Red Hat Display", sans-serif', maxWidth:"160px" }}>IRDA License No : IMF09640820250838</p>

                            <Link to="#" style={{
                                fontSize: "22px",
                                color: "#00041b",
                                backgroundColor: "transparent",
                                padding: "5px",

                            }} >
                                <i className="far fa-search" onClick={() => { setBtnshow(true) }} />
                            </Link>
                            {/* <Link to="/contact" className="thm-btn">
                        <span>
                        Get a Quote <i className="far fa-arrow-right" />
                        </span>
                    </Link> */}

                            <HashLink
                                smooth
                                to="/#getaquote"
                                className="thm-btn"
                            >
                                <span>
                                    Get a Quote <i className="far fa-arrow-right" />
                                </span>
                            </HashLink>
                            <button className='thm-btn' onClick={() => window.location.href = 'https://auth.finrelinsure.com'}>
                                <span> Login </span>
                            </button>

                            {/* <Link to="#" className="main-menu__toggler side-drawer__toggler" onClick={() => setShow(true)}>
                        <span />
                        <span />
                        <span />
                    </Link> */}
                        </div>

                    </div>
                </nav>

            </header>

            {Mobile &&
                <div className={`mobile-nav__wrapper ${"expanded"}`}>
                    <div className="mobile-nav__overlay mobile-nav__toggler" />

                    <div className="mobile-nav__content">
                        <Link to="#" className="mobile-nav__close mobile-nav__toggler" onClick={() => setMobile(false)}>
                            <span />
                            <span />
                        </Link>
                        <div className="logo-box">
                            <Link to="/" aria-label="logo image">
                                <img src={Img} alt="Finreliable Technology" style={{ height: '60px', width: 'auto' }} />
                            </Link>
                        </div>

                        <div className="mobile-nav__container">

                            <ul className="mobile-menu__list">
                                <li className="menu-item-has-children current">
                                    <Link to="/" onClick={() => setHome(!Home)}>
                                        Home

                                    </Link>

                                </li>
                                <li className="menu-item-has-children">
                                    <Link to="/about" onClick={() => setPage(!Page)}>
                                        About us
                                    </Link>


                                </li>

                                <li className="menu-item-has-children">
                                    <Link to="#" onClick={() => setInsurances(!Insurances)}>
                                        Insurances
                                        <button aria-label="dropdown toggler">
                                            <i className="fa fa-angle-down" />
                                        </button>
                                    </Link>
                                    {Insurances &&
                                        <ul style={{ display: "block" }}>
                                            <li>
                                                <Link to="/insurances">Insurance </Link>
                                            </li>
                                            <li>
                                                <Link to="/insurancesdetails">Insurances details</Link>
                                            </li>
                                            <li>
                                                <Link to="/pay-premium">Pay Premium</Link>
                                            </li>
                                        </ul>
                                    }
                                    <li className="menu-item-has-children">
                                        <Link to="/insurances">Booking</Link>
                                        <ul>
                                            <li>
                                                <Link to="/insurances">Ferry</Link>
                                            </li>
                                        </ul>
                                    </li>
                                </li>
                                <li className="menu-item-has-children">
                                    <Link to="/insurances">Booking</Link>
                                    <ul>
                                        <li>
                                            <Link to="/insurances">Ferry</Link>
                                        </li>
                                    </ul>
                                </li>
                                {/* <li className="menu-item-has-children">
                                    <Link to="#" onClick={() => setPortfolio(!Portfolio)} > Portfolio
                                        <button aria-label="dropdown toggler">
                                            <i className="fa fa-angle-down" />
                                        </button>
                                    </Link>
                                    {Portfolio &&
                                        <ul style={{ display: "block" }}>
                                            <li>
                                                <Link to="/portfoliogrid">Portfolio grid</Link>
                                            </li>
                                            <li>
                                                <Link to="/portfoliomasonary">Portfolio masonary</Link>
                                            </li>
                                            <li>
                                                <Link to="/portfoliodetails">Portfolio details</Link>
                                            </li>
                                        </ul>
                                    }
                                </li> */}
                                {/* <li className="menu-item-has-children">
                                    <Link to="#" onClick={() => setBlog(!Blog)} > Blog
                                        <button aria-label="dropdown toggler">
                                            <i className="fa fa-angle-down" />
                                        </button>
                                    </Link>
                                    {Blog &&
                                        <ul style={{ display: "block" }} >
                                            <li>
                                                <Link to="/blog">Blog</Link>
                                            </li>
                                            <li>
                                                <Link to="/blogdetails">Blog details</Link>
                                            </li>
                                        </ul>
                                    }
                                </li> */}
                                <li>
                                    <Link to="/contact">Contact</Link>
                                </li>
                            </ul>
                        </div>


                        <ul className="list-unstyled footer-one__widget__contact">
                            <li>
                                <i className="far fa-envelope-open" />
                                <Link to="mailto:service1@finrelinsure.com">service1@finrelinure.com</Link>
                            </li>
                            <li>
                                <i className="far fa-phone-plus" />
                                <Link to="tel:+000(123)45688">08069627000</Link>
                            </li>
                        </ul>

                        {/* <ul className="list-unstyled footer-one__widget__social">
                            <li>
                                <Link to="#">
                                    <i className="fab fa-facebook-f" />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fab fa-twitter" />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fab fa-linkedin-in" />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fab fa-instagram" />
                                </Link>
                            </li>
                        </ul> */}

                    </div>

                </div>
            }

            {/* {Show && 
            <div className={`side-drawer__wrapper ${"expanded"}`}>
                <div className="side-drawer__overlay side-drawer__toggler" />
                
                <div className="side-drawer__content">
                <Link to="#" className="side-drawer__close side-drawer__toggler" onClick={() => setShow(false)}>
                    <span />
                    <span />
                </Link>
                <div className="logo-box">
                    <Link to="/" aria-label="logo image">
                    <img src="assets/images/og-logo.png" alt="Finreliable Technology" style={{ height: '60px', width: 'auto' }} />
                    </Link>
                </div>
            
                <div className="footer-one__widget">
                    <h3 className="footer-one__widget__title">About</h3>
                    
                    <p className="footer-one__widget__text">
                    We denounce righteous indignations dislike men beguiled and
                    demoralized charms of pleasure moment
                    </p>
                    
                    <ul className="list-unstyled footer-one__widget__social">
                    <li>
                        <Link to="#">
                        <i className="fab fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <Link to="#">
                        <i className="fab fa-twitter" />
                        </Link>
                    </li>
                    <li>
                        <Link to="#">
                        <i className="fab fa-linkedin-in" />
                        </Link>
                    </li>
                    <li>
                        <Link to="#">
                        <i className="fab fa-instagram" />
                        </Link>
                    </li>
                    </ul>
                    
                </div>
                
                <div className="footer-one__widget">
                    <h3 className="footer-one__widget__title">Gallery</h3>
                    
                    <ul className="list-unstyled footer-one__widget__gallery">
                    <li>
                        <Link to="assets/images/resources/footer-g-1.jpg" className="img-popup" >
                        <img src="assets/images/resources/footer-g-1.jpg"  />
                        <span className="footer-one__widget__gallery__hover">
                            <i className="fab fa-instagram" />
                        </span>
                        
                        </Link>
                    </li>
                    <li>
                        <Link to="assets/images/resources/footer-g-2.jpg"
                        className="img-popup" >
                        <img src="assets/images/resources/footer-g-2.jpg"  />
                        <span className="footer-one__widget__gallery__hover">
                            <i className="fab fa-instagram" />
                        </span>
                        
                        </Link>
                    </li>
                    <li>
                        <Link to="assets/images/resources/footer-g-3.jpg" className="img-popup" >
                        <img src="assets/images/resources/footer-g-3.jpg"  />
                        <span className="footer-one__widget__gallery__hover">
                            <i className="fab fa-instagram" />
                        </span>
                        
                        </Link>
                    </li>
                    <li>
                        <Link to="assets/images/resources/footer-g-4.jpg" className="img-popup" >
                        <img src="assets/images/resources/footer-g-4.jpg"  />
                        <span className="footer-one__widget__gallery__hover">
                            <i className="fab fa-instagram" />
                        </span>
                        
                        </Link>
                    </li>
                    <li>
                        <Link to="assets/images/resources/footer-g-5.jpg" className="img-popup" >
                        <img src="assets/images/resources/footer-g-5.jpg"  />
                        <span className="footer-one__widget__gallery__hover">
                            <i className="fab fa-instagram" />
                        </span>
                        
                        </Link>
                    </li>
                    <li>
                        <Link to="assets/images/resources/footer-g-6.jpg" className="img-popup" >
                        <img src="assets/images/resources/footer-g-6.jpg"  />
                        <span className="footer-one__widget__gallery__hover">
                            <i className="fab fa-instagram" />
                        </span>
                        
                        </Link>
                    </li>
                    </ul>
                    
                </div>
                
                <div className="footer-one__widget">
                    <h3 className="footer-one__widget__title">Contact</h3>
                    <ul className="list-unstyled footer-one__widget__contact">
                    <li>
                        <i className="far fa-envelope-open" />
                        <Link to="mailto:service1@finrelinsure.com">service1@finrelinsure.com</Link>
                    </li>
                    <li>
                        <i className="far fa-phone-plus" />
                        <Link to="tel:+000(123)45688">+000 (123) 456 88</Link>
                    </li>
                    </ul>
                    
                </div>
                
                </div>
                
            </div> 
         } */}

            {Btnshow &&
                <div className={`search-popup ${"active"}`} onClick={() => setBtnshow(false)}>

                    <div className="search-popup__overlay search-toggler" />
                    <div className="search-popup__content">
                        <form action="#">
                            <label htmlFor="search" className="sr-only">
                                search here
                            </label>

                            <input type="text" id="search" placeholder="Search Here..." />
                            <button type="submit" aria-label="search submit" className="thm-btn">
                                <span>
                                    <i className="far fa-search" />
                                </span>
                            </button>
                        </form>
                    </div>
                </div>
            }

        </>
    )
}

export default Header